import { Component } from "react";
import { Navigate } from "react-router-dom";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminPageComponent } from "../common/selltowebpage/SellToWebAdminPageComponent";
import { SellToWebInputComponent } from "../common/selltowebinput/SellToWebInputComponent"

import { XSRFTest1QueryComponent } from "./XSRFTest1QueryComponent";

export class XSRFTest1RouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingData: false,
            token: "",
            vin: "Test1",
            redirectTo: ""
        };

        this.onChange = this.onChange.bind(this);
        this.onGetPageInfo = this.onGetPageInfo.bind(this);
        this.onActionWithValidation = this.onActionWithValidation.bind(this);
        this.onActionWithoutValidation = this.onActionWithoutValidation.bind(this);
        this.onGoToXSRF2 = this.onGoToXSRF2.bind(this);
        this.onGoToXSRF3 = this.onGoToXSRF3.bind(this);
    }

    pageTitle = "XSRF Test 1";

    componentDidMount() {
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "componentDidMount");
        }
    }

    onGetPageInfo() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest1RouteComponent/onGetPageInfo", properties: { logon: this.props.logon } });
            fetch("/XSRFTest1/GetPageInfo", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS"),
                        isLoadingData: false
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest1/ValidateWithKey", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest1RouteComponent", "onGetPageInfo");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest1RouteComponent", "onGetPageInfo");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "onGetPageInfo");
        }
    }

    onChange(id, value) {
        try {
            this.setState({ [id]: value })
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "onChange");
        }
    }

    onActionWithValidation() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest1RouteComponent/onActionWithValidation", properties: { logon: this.props.logon } });

            let inputData = {
                vin: this.state.vin
            };
            fetch("/XSRFTest1/ActionWithValidation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": this.state.token
                },
                credentials: "same-origin",
                body: JSON.stringify(inputData)
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS"),
                        isLoadingData: false
                    });
                    if (parsedResponse.success) {
                        this.props.onShowAlert("success", { message: "Anti-Forgery Validation Successfull.!" }, 4000);
                    }
                    else {
                        this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Failed." });
                    }
                    this.setState({ isLoadingData: false });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Failed." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest1/ActionWithValidation", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest1RouteComponent", "onActionWithValidation");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest1RouteComponent", "onActionWithValidation");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "onActionWithValidation");
        }
    }

    onActionWithoutValidation() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest1RouteComponent/onActionWithoutValidation", properties: { logon: this.props.logon } });
            fetch("/XSRFTest1/ActionWithoutValidation", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    if (parsedResponse.success) {
                        this.props.onShowAlert("success", { message: "Anti-Forgery Validation Skipped.!" }, 4000);
                    }
                    else {
                        this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Skip Failed." });
                    }
                    this.setState({ isLoadingData: false });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Skipped." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest1/ActionWithoutValidation", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest1RouteComponent", "onActionWithoutValidation");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest1RouteComponent", "onActionWithoutValidation");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "onActionWithoutValidation");
        }
    }

    onGoToXSRF2() {
        try {
            this.setState({
                redirectTo: "/Demo/XSRFTest2"
            });
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "onGoToXSRF2");
        }
    }

    onGoToXSRF3() {
        try {
            this.setState({
                redirectTo: "/Demo/XSRFTest3"
            });
        }
        catch (error) {
            console.logError(error, "XSRFTest1RouteComponent", "onGoToXSRF3");
        }
    }

    render() {
        if (this.state.redirectTo) {
            console.log("Redirecting to ", this.state.redirectTo);
            return <Navigate to={this.state.redirectTo} />;
        }
        return <SellToWebAdminPageComponent>
            <div className="admin-flex-item admin-body">
                <div className="d-flex flex-column admin-fill-content">
                    <XSRFTest1QueryComponent isLoadingData={this.state.isLoadingData} onShowAlert={this.props.onShowAlert} applicationInsights={this.props.applicationInsights}
                        onGetPageInfo={this.onGetPageInfo} onActionWithValidation={this.onActionWithValidation} onActionWithoutValidation={this.onActionWithoutValidation}
                        onGoToXSRF2={this.onGoToXSRF2} onGoToXSRF3={this.onGoToXSRF3} />
                    <br />
                    <div className="card">
                        <div className="card-block" style={{ "padding": "10px" }}>
                            <strong>Page Cookies:</strong><br />
                            {decodeURIComponent(document.cookie)}<br /><br />
                            <strong>XSRF Token:</strong><br />
                            {CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")}<br /><br />
                            <SellToWebInputComponent id="token" value={this.state.token} label="Token" onTextChange={this.onChange} />
                            <SellToWebInputComponent id="vin" value={this.state.vin} label="VIN (Also Set AdditionalData's VIN)" onTextChange={this.onChange} />
                        </div>
                    </div>
                </div>
            </div>
        </SellToWebAdminPageComponent>;
    }
}